import { createSelector } from 'reselect';

import type { SpartacuxProB2BServicesState } from '../../store/store.interface';

export const getProB2BServices = (state: SpartacuxProB2BServicesState) =>
  state.proB2BServices;

export const getWishlists = createSelector(
  getProB2BServices,
  (slice?) => slice?.wishlists,
);

export const getWishlistsNotification = createSelector(
  getWishlists,
  (slice) => slice?.notification,
);

export const getWishlistsModal = createSelector(
  getWishlists,
  (slice) => slice?.modalToOpen,
);
